import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Dropdown.css";
import * as React from "react";
import { ExpandableTextField } from '../../ExpandableTextField';
import { css } from '../../Util';
export function DropdownExpandableTextField(props) {
    var editable = props.editable, expandableRef = props.expandableRef, items = props.items, inputClassName = props.inputClassName, onFocus = props.onFocus, renderSelectedItems = props.renderSelectedItems, selection = props.selection, rest = tslib_1.__rest(props, ["editable", "expandableRef", "items", "inputClassName", "onFocus", "renderSelectedItems", "selection"]);
    var text;
    if (!editable) {
        text = props.placeholder;
        if (selection.selectedCount > 0) {
            text = renderSelectedItems(selection, items);
        }
    }
    return (React.createElement(ExpandableTextField, tslib_1.__assign({ inputType: !editable ? "button" : undefined, ref: expandableRef, value: text, focusTreatment: editable ? 0 /* all */ : 1 /* keyboardOnly */ }, rest, { onFocus: editable
            ? function (event) {
                if (expandableRef.current) {
                    expandableRef.current.expand();
                }
                if (onFocus) {
                    onFocus(event);
                }
            }
            : onFocus, inputClassName: css(inputClassName, "flex-row") })));
}
